<template>
    <Teleport to='body'>
        <transition name='vue-modal'>
            <div class='modal' v-if='isOpen' :class='modalClasses'>
                <div class='modal__close' @click='closeModal'>
                    <a class='cta cta--small' :class='{"cta--alt": isDarkMode}'>
                        <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 13L13 1M1 1L13 13' stroke='#3D3B39' stroke-width='0.8' vector-effect='non-scaling-stroke' stroke-linecap='round' stroke-linejoin='round'/></svg>
                    </a>
                </div>
                <div class='modal__membrane'>
                    <slot></slot>
                </div>
            </div>
        </transition>
    </Teleport>
</template>

<script>
import Media from '@/components/elements/Media.vue';
import AjaxForm from '@/components/elements/AjaxForm.vue';

export default {
    name: 'Modal',
    props: {
        isDarkMode: {
            type: Boolean,
            default: false
        },
        class: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isInitialized: false,
            isOpen: false
        }
    },
    computed: {
        modalClasses () {
            return [this.class, {
                'state-initialized': this.isInitialized,
                'modal--dark': this.isDarkMode
            }]
        }
    },
    mounted () {
        this.isInitialized = true;
    },
    beforeUnmount () {
        this.closeModal();
    },
    methods: {
        toggleModal () {
            if (this.isOpen) {
                this.closeModal();
            } else {
                this.openModal();
            }
        },
        openModal () {
            // fix body so background doesnt scroll
            document.body.style.top = `-${window.scrollY}px`;
            document.body.style.position = 'fixed';
            document.body.style.maxWidth = 'calc(100% - var(--scrollbar-width))';

            this.isOpen = true;
        },
        closeModal () {
            // unfix the body on close
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.maxWidth = '';
            
            window.scrollTo({
                top: parseInt(scrollY || '0') * -1,
                behavior: 'instant'
            });

            this.isOpen = false;
        }
    },
    components: {
        Media,
        AjaxForm
    }
};
</script>